import { render, staticRenderFns } from "./FormInputGroups.vue?vue&type=template&id=1f184b46"
import script from "./FormInputGroups.vue?vue&type=script&lang=js"
export * from "./FormInputGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports